import { useCallback, useRef, useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useTabStore } from '../store/tabStore'
import { usePageRefreshStore } from '../store/pageRefreshStore'

/** Reload the active tab pane and refetch its React Query data. */
export function useRefreshCurrentTab() {
  const queryClient = useQueryClient()
  const [isRefreshing, setIsRefreshing] = useState(false)
  const busyRef = useRef(false)

  const refresh = useCallback(async () => {
    if (busyRef.current) return
    busyRef.current = true
    setIsRefreshing(true)
    try {
      const tabId = useTabStore.getState().activeTabId
      await queryClient.invalidateQueries()
      usePageRefreshStore.getState().bump(tabId)
    } finally {
      window.setTimeout(() => {
        busyRef.current = false
        setIsRefreshing(false)
      }, 450)
    }
  }, [queryClient])

  return { refresh, isRefreshing }
}
